import React from "react";

const AbmOptionsBus = (props) => {
  const options = [
    {
      text: 'Qu’est-ce que le service Comptant INTERAC?',
      handler: props.actionProvider.AbmBus1,
      id: 1
    },
    {
      text: 'Comment ce service peut-il aider mon entreprise?',
      handler: props.actionProvider.AbmBus2,
      id: 2
    },
    {
      text: 'Combien puis-je facturer pour chaque transaction au GAB?',
      handler: props.actionProvider.AbmBus3,
      id: 3
    },
    {
      text: 'Que se passe-t-il si quelqu’un utilise une carte de débit volée pour retirer de l’argent à l’aide de mon GAB?',
      handler: props.actionProvider.AbmBus4,
      id: 4
    },
    {
      text: 'J’ai des questions sur les frais et l’installation. Où puis-je trouver de plus amples renseignements?',
      handler: props.actionProvider.AbmBus5,
      id: 5
    },
    {
      text: 'J’ai de la difficulté avec mon GAB Comptant Interac. Pouvez-vous m’aider?',
      handler: props.actionProvider.AbmBus6,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default AbmOptionsBus;